import * as React from "react";

import { cn } from "@facade/lib/utils";

interface InputProps extends React.ComponentProps<"input"> {
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  invalid?: boolean;
  containerClassName?: string;
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
}

export function Input({
  ref,
  className,
  containerClassName,
  type,
  startAdornment,
  endAdornment,
  invalid,
  containerProps,
  ...props
}: InputProps) {
  return (
    <div
      data-slot="input-container"
      className={cn(
        "flex w-full h-[30px] min-w-0 items-center gap-2 rounded-md border border-input bg-input/20 px-2 py-1.5 transition-colors",
        "focus-within:border-ring focus-within:ring-2 focus-within:ring-ring/30",
        "dark:bg-input/30",
        invalid &&
          "border-destructive ring-2 ring-destructive/20 focus-within:border-destructive focus-within:ring-destructive/30",
        containerClassName,
      )}
      {...containerProps}
    >
      {startAdornment && (
        <div className="flex shrink-0 text-muted-foreground">
          {startAdornment}
        </div>
      )}

      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          "flex-1 bg-transparent text-xs outline-none placeholder:text-muted-foreground",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          "md:text-md/relaxed",
          className,
        )}
        {...props}
      />

      {endAdornment && (
        <div className="shrink-0 text-muted-foreground">{endAdornment}</div>
      )}
    </div>
  );
}
